import { render, staticRenderFns } from "./UserGradeList.vue?vue&type=template&id=8cddec26&scoped=true"
import script from "./UserGradeList.vue?vue&type=script&lang=js"
export * from "./UserGradeList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cddec26",
  null
  
)

export default component.exports